// src/services/api/AuthApiService.ts
import { IAuthPostDto } from 'shared/interfaces';
import BaseApiService from './BaseApiService';

class AuthApiService extends BaseApiService {
  constructor() {
    // базовый путь — пустой, потому что бэк принимает напрямую /login /register
    super('');
  }

  // 🔹 Авторизация
  login(authData: IAuthPostDto): Promise<{ token: string }> {
    return this.POST('login', authData);
  }

  // 🔹 Основная регистрация
  register(authData: any): Promise<any> {
    return this.POST('register', authData);
  }

  // 🔹 Дополнительная регистрация (например, AtavismDB)
  registerSecondary(authData: { username: string; password: string; email?: string }): Promise<Response> {
    // здесь мы используем fetch напрямую, потому что BaseApiService может не поддерживать другой эндпоинт
    return fetch('https://api.cyberfit.pro/register_a', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(authData),
    });
  }
}

export default new AuthApiService();
